import { useState } from 'react'
import { Button, Divider, Flex, Form, Image, Input, Modal, Typography } from 'antd'

import { Guard } from '../../../../../features/session/guard'
import { EGiftOrderStatuses } from '../../const'
import { GiftOrder } from '../../list/types'
import { submitActionStatus } from '../actionChangeStatusModal/model'

type Props = {
  isVisible: boolean
  onClose: () => void
  data: GiftOrder
}

export const ReviewTaskModal = ({ isVisible, onClose, data }: Props) => {
  const [isDecline, setIsDecline] = useState(false)

  const [form] = Form.useForm()
  const { Item } = Form
  const { Text } = Typography
  const { TextArea } = Input

  const handleClose = () => {
    setIsDecline(false)
    form.resetFields()
    onClose()
  }

  const handleApprove = () => {
    submitActionStatus({
      id: String(data.id),
      status: EGiftOrderStatuses.SENT,
      managerComment: '',
    })
    handleClose()
  }

  const handleReject = async () => {
    if (!isDecline) {
      setIsDecline(true)
      return
    }
    try {
      const values = await form.validateFields()
      submitActionStatus({
        id: String(data.id),
        status: EGiftOrderStatuses.CANCELED,
        managerComment: values.managerComment,
      })
      handleClose()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Gift order {data.id}</div>}
      centered
      wrapClassName="ant_modal"
      width={700}
      maskClosable={false}
      open={isVisible}
      onCancel={handleClose}
      footer={
        <Flex gap={8} justify="flex-end">
          <Guard permission={['edit_gift_order', 'process_gift_order']}>
            <Button color="green" variant="solid" onClick={handleApprove}>
              Approve
            </Button>
            <Button color="volcano" variant="solid" onClick={handleReject}>
              Reject
            </Button>
          </Guard>
        </Flex>
      }
    >
      <Divider />
      <Flex vertical>
        <div className="mb-2">
          <span className="text-muted">Client:</span> {data.client.fullName}
        </div>
        <div className="mb-2">
          <span className="text-muted">Gift:</span> {data.gift.name}
        </div>
        {data.fileUrl && (
          <Image className="mb-3" width={300} src={data.fileUrl} />
        )}
        {isDecline && (
          <Form layout="vertical" form={form}>
            <Item
              name="managerComment"
              label={
                <Text style={{ fontSize: 16 }} strong>
                  Decline reason
                </Text>
              }
              rules={[
                {
                  required: true,
                  message: 'Required field',
                },
              ]}
            >
              <TextArea rows={6} autoFocus placeholder="Reason" />
            </Item>
          </Form>
        )}
      </Flex>
      <Divider />
    </Modal>
  )
}
